export const AUTH_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/recuperar-password',
  CHANGE_PASSWORD: '/perfil/cambiar-password',
} as const;

/** Route to redirect users to after successful login. */
export const POST_LOGIN_ROUTE = '/protocolos';
